import jwtDecode from 'jwt-decode';

import { clearPopup, showPopup, FeatureSlider } from './utils';
import billingSDK from './billing';
import authService from './authService/auth';

const headerMenu = document.querySelector('.header-menu');
const signOutButton = document.querySelector('.sign-out-button');
const upgradePlanButton = document.querySelector('.account-menu a:nth-of-type(2)');

authService.init(() => {});

const signOutModal = () => {
    showPopup();
    setTimeout(() => {
        clearPopup();
        authService.clear();
        headerMenu.classList.remove('logged', 'active');
        document.querySelector('.header').classList.remove('active');
        gtag('event', 'Account sign out'); // eslint-disable-line no-undef
    }, 300);
};

headerMenu.classList.add('loading');
billingSDK.getPaymentProfile().then(
    response => {
        headerMenu.classList.remove('loading');
        const { data, message } = response; // eslint-disable-line camelcase
        if (message) {
            headerMenu.classList.remove('logged');
        } else {
            headerMenu.classList.add('logged');
            document.querySelector('.account-user span').innerHTML = authService.getUserName(jwtDecode);
            if (data.payment_customer_id) { // eslint-disable-line camelcase
                upgradePlanButton.style.display = 'none';
            } else {
                upgradePlanButton.style.display = 'flex';
            }
        }
    }
);
signOutButton.addEventListener('click', signOutModal);

const wrapper = document.querySelector('.identify-picture');
const controls = document.querySelectorAll('.identify-picture-wrapper div');
const left = document.querySelector('.identify-picture-img .left-control');
const right = document.querySelector('.identify-picture-img .right-control');
const sliderFirst = new FeatureSlider(6000, wrapper, controls, left, right);
sliderFirst.load();

const wrapperSliderSecond = document.querySelector('.identification-fields');
const controlsSliderSecond = document.querySelectorAll('.identification-options-wrapper > div');
const leftSliderSecond = document.querySelector('.identification-fields-pic .left-control');
const rightSliderSecond = document.querySelector('.identification-fields-pic .right-control');
const sliderSecond = new FeatureSlider(6000, wrapperSliderSecond, controlsSliderSecond, leftSliderSecond, rightSliderSecond);
sliderSecond.load();

const observer = new IntersectionObserver((entries, observer) => { // eslint-disable-line no-undef
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
        }
    });
}, { threshold: 1 });

document.querySelectorAll('.bottom-plant__hdr').forEach(item => observer.observe(item));
document.querySelectorAll('.instruction').forEach(item => observer.observe(item));

const setScroll = () => {
    const scroll = document.querySelector('.users-say-reviews');
    const { width } = scroll.getBoundingClientRect();
    const { scrollWidth } = scroll;
    scroll.scrollLeft = (scrollWidth - width) / 2;
};

setScroll();

window.addEventListener('resize', () => setScroll());
